import { InputAdornment, Stack, TextField } from "@mui/material"
import { Controller, useFormContext } from "react-hook-form"
import { CreateServiceLevel } from "../../utils/types/generals"
import { TimesEnum, validateTime } from "./validate";
import { ChangeEvent } from "react";

export function ResolutionTimeRow({ index, name, disable }: { index: number; name: string, disable:boolean }) {
  const form = useFormContext()

  function handleChange(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, nameType?: TimesEnum) {
    const value = event.target.value.replace(/\D/, "")
    const oldValue = form.getValues(`${name}.${index}.${nameType}`)
    const localeName = event.target.name as keyof CreateServiceLevel
    const newValue = event.type == 'blur' && !value ? '0' : value
    const valueValidated = validateTime({ name: nameType, newValue: Number(newValue), oldValue })
    form.setValue(localeName, Number(valueValidated))
  }

  return (
    <Stack direction={"row"} spacing={1}>
      <Controller
        control={form.control}
        name={`${name}.${index}.days`}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            onChange={handleChange}
            onBlur={handleChange}
            disabled={disable}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">días</InputAdornment>
              ),
            }}
          />
        )}
      />
      <Controller
        control={form.control}
        name={`${name}.${index}.hours`}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            onChange={(e) => {
              handleChange(e, TimesEnum.HOURS)
            }}
            onBlur={handleChange}
            disabled={disable}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">horas</InputAdornment>
              ),
            }}
          />
        )}
      />
      <Controller
        control={form.control}
        name={`${name}.${index}.minutes`}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            onChange={(e) => {
              handleChange(e, TimesEnum.MINUTES)
            }}
            onBlur={handleChange}
            disabled={disable}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            InputProps={{
              endAdornment: <InputAdornment position="end">min</InputAdornment>,
            }}
          />
        )}
      />
      <Controller
        control={form.control}
        name={`${name}.${index}.seconds`}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            onChange={(e) => {
              handleChange(e, TimesEnum.SECONDS)
            }}
            onBlur={handleChange}
            disabled={disable}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">segs</InputAdornment>
              ),
            }}
          />
        )}
      />
    </Stack>
  )
}